import { connect } from "react-redux";
import AgentsComponent from "../../Components/Agents/AgentsComponent";
import { setAgents } from "../../Redux/Actions/AgentsActions";
const mapStateToProps = (state) => ({
  
    SCOPES_NAMES : state.reducer.SCOPES_NAMES,
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    SCOPE_AVAILABLE_LICENCES : state.reducer.SCOPE_AVAILABLE_LICENCES,
    AGENT_PROFILES : state.reducer.AGENT_PROFILES,

});
const mapDispatchToProps = (dispatch) => ({
    setAgents : (AGENTS) => dispatch(setAgents(AGENTS)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(AgentsComponent);